








































import { Prop, Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import HeaderInfo from '@/components/App/Modules/GMS/Grants/ExpansionPanel/ExpansionPanel.vue';

const namespace: string = "grantAmendment";

@Component({
    components: {
        HeaderInfo
    }
})

export default class GrantsActivityLogComponent extends Vue {
    @Action("StartAmendmentDetail", { namespace }) startAmendmentDetail: any;

    @Prop() GrantInfo: any;
    @Prop() GrantAmendment: any;
    @Prop() UserRole: any;

    headers: any = [];
    editIcon = 'mdi-pencil-outline';
    viewIcon = 'mdi-file-search-outline';
    actions = _app.actions;
    subjects = _app.subjects;

    mounted() {
        this.headers = _app.amendmentDetailsHeaders;
        this.headers.map(x => {
            x.text = this.$t(x.text);
        });
    }

    formatDate(dt: any) {
        return utils.formatDate(dt);
    }

    /** edit the selected item */
    editItem(item: any) {
        const amendmentType = _app.amendmentTypes.find(x => x.value == item.AmendmentTypeId).type;

        if (item.WorkflowStatusCode == 'NOTS') {
            this.startAmendmentDetail(item.GrantAmendmentDetailId).then(() => {
                this.$router.push({
                    name: "amendmentDetail",
                    params: { amendmentType: amendmentType, amendmentDetailId: item.GrantAmendmentDetailId }
                });
            });
        } else {
            this.$router.push({
                name: "amendmentDetail",
                params: { amendmentType: amendmentType, amendmentDetailId: item.GrantAmendmentDetailId }
            });
        }
    }

    hasPermission(item) {
        switch (item.AmendmentTypeId) {
            case 4899:
                //@ts-ignore
                return this.$can(this.actions.update, this.subjects.noCostAmendment);

            case 4900:
                //@ts-ignore
                return this.$can(this.actions.update, this.subjects.budgetAmendment);

            case 4901:
                //@ts-ignore
                return this.$can(this.actions.update, this.subjects.technicalAmendment);

            case 4903:
                //@ts-ignore
                return this.$can(this.actions.update, this.subjects.suspension);
                
            case 4904:
                //@ts-ignore
                return this.$can(this.actions.update, this.subjects.termination);
                
            case 4905:
                //@ts-ignore
                return this.$can(this.actions.update, this.subjects.termination);
        }
    }

    isAuditor() {
        if (this.UserRole == _app.appRoles.Auditor) {
            return true;
        }
    }
}
